import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Pagination {
  currentPage: number;
  lastPage: number;
  perPage: number;
  total: number;
}

const initialPagination: Pagination = {
  currentPage: 1,
  lastPage: 1,
  perPage: 10,
  total: 0,
};

interface AccountingState {
  loading: boolean;
  error: any | null;
  pagination: Pagination;
}

const initialState: AccountingState = {
  loading: false,
  error: null,
  pagination: initialPagination,
};

/**
 * @deprecated This slice acts as a partial facade replacement for the Vue accountingStore.
 * It primarily holds global loading/error and pagination state.
 * For specific data fetching, use the specific RTK Query APIs directly.
 */
export const accountingSlice = createSlice({
  name: 'accounting',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<any>) {
      state.error = action.payload;
      state.loading = false;
    },
    clearError(state) {
      state.error = null;
    },
    setPagination(state, action: PayloadAction<Partial<Pagination>>) {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    clearState() {
      // Return a fresh object (and a fresh pagination): handing back the
      // module-level `initialState` aliased live Redux state to it.
      return {
        loading: false,
        error: null,
        pagination: { ...initialPagination },
      };
    },
  },
});

export const { setLoading, setError, clearError, setPagination, clearState } = accountingSlice.actions;

export default accountingSlice.reducer;
